<template lang="pug">
  decorators-background
    social-network-publish(
      :hero-id="heroId"
      :label="label"
      :avatar="$get(me, 'image')"
      :on-go-to-publish="() => $createOnClick({ onGoToPublish })")
    social-network-feed(
      :posts="posts"
      :get-id="getId"
      :get-author="getAuthor"
      :get-content="getContent"
      :get-image="getImage"
      :get-created-at="getCreatedAt"
      :get-likes-count="getLikesCount"
      :get-comments-count="getCommentsCount"
      :is-liked="isLiked"
      :on-like="onLike"
      :on-unlike="onUnlike"
      :on-click-more="onClickMore"
      :on-go-to-author="onGoToAuthor"
      :on-go-to-comments="onGoToComments"
      :on-go-to-comments-to-comment="onGoToCommentsToComment")
      template(#avatar="{ post }")
        feature-avatar.v-list-item__avatar(
          @click="onGoToAuthor(post)"
          :src="$get(post.author.image, 'src')"
          :lazy-src="$get(post.author.image, `srcLazy`)")
</template>

<script>
import data from '@iez/lib/data/'
import router from '@iez/core/router/'
import { reactive, toRefs, onMounted, ref, computed } from '@vue/composition-api'
import user from '@iez/lib/user/'
import { page } from '@iez/core'
import { mdiPencil, mdiDelete } from '@mdi/js'
import { addOverflowDependency } from '@iez/core/router/'

import SocialNetworkFeed from '@iez/components/social-network/feed/'
import SocialNetworkPublish from '@iez/components/social-network/publish/'
import DecoratorsBackground from '@iez/components/decorators/background/'

const labelLoop = {
  index: ref(0),
  labels: [
    `Partagez vos actions`,
    `Sensibilisez à une cause`
  ]
}

export default {
  components: {
    SocialNetworkFeed,
    SocialNetworkPublish,
    DecoratorsBackground
  },

  setup () {
    labelLoop.index.value++
    const label = computed(
      () => labelLoop.labels[labelLoop.index.value % labelLoop.labels.length]
    )

    const posts = data.get({
      root: `posts`,
      fields: [
        `id`,
        `content`,
        `createdAt`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ],
          likesPosts: [
            `id`,
            `authorId`,
            `postId`
          ],
          author: [
            `id`,
            `name`, {
              image: [
                `id`,
                `src`,
                `srcLazy`
              ]
            }
          ],
          comments: [`id`]
        }
      ],
      request: {
        order_by: {
          createdAt: `desc`
        },
        where: {
          _or: [{
            author: {
              followsUsersFollowers: {
                followerId: {
                  _eq: user.id
                }
              }
            }
          }, {
            authorId: {
              _eq: user.id
            }
          }]
        }
      }
    })
    console.log(posts)

    onMounted(() => {
      addOverflowDependency({
        dependency: () => posts.value?.length
      })
    })

    const me = data.me({
      fields: [
        `id`,
        `isAdmin`,
        `name`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ],
          likesPosts: [
            `id`,
            `postId`
          ],
          posts: [
            `id`
          ]
        }
      ]
    })

    const state = reactive({
      posts,
      me,
      heroId: `Home-heroId-PublishAavatar`
    })

    const onGoToPublish = () => {
      router.push({
        name: `PostCreate`,
        params: {
          userId: null
        },
        query: {
          heroIdPublishAvatar: state.heroId
        }
      })
    }

    const onLike = async post => {
      await data.set({
        root: `likesPosts`,
        items: [{
          authorId: user.id,
          postId: post.id
        }],
        fields: [
          `id`
        ],
        parents: [{
          root: `posts`,
          id: post.id
        }, {
          root: `users`,
          id: user.id
        }]
      })
    }

    const onUnlike = async post => {
      await data.remove({
        root: `likesPosts`,
        ids: post.likesPosts
          .filter(({ authorId }) => authorId === user.id)
          .map(({ id }) => id),
        parents: [{
          root: `users`,
          id: user.id
        }, {
          root: `posts`,
          id: post.id
        }]
      })
    }

    const postBeingManaged = ref(null)
    page.blockingMenu.set(
      () => postBeingManaged.value
        ? {
          title: `Gestion de la publication`,
          onClose: () => {
            postBeingManaged.value = null
          },
          items: [{
            label: `Modifier`,
            icon: mdiPencil,
            onClick: () => {
              router.push({
                name: `PostCreate`,
                params: {
                  postId: postBeingManaged.value.id
                }
              })
            }
          }, {
            label: `Supprimer`,
            icon: mdiDelete,
            onClick: async () => {
              page.confirm({
                title: `Confirmez-vous la suppression ?`,
                callback: async () => {
                  await data.remove({
                    root: `posts`,
                    ids: postBeingManaged.value.id,
                    parents: []
                  })
                  postBeingManaged.value = false
                  page.bottomSnackbar.set({
                    content: `Publication supprimée`
                  })
                }
              })
            }
          }]
        } : null
    )

    const onClickMore = post =>
      isMine(post) || me.value?.isAdmin
        ? () => {
          postBeingManaged.value = post
        } : null

    const onGoToAuthor = post => {
      const isMine = post.author.id === user.id

      router.push({
        name: `Profile`,
        ...!isMine
          ? {
            params: {
              id: post.author.id
            },
            query: {
              heroIdProfileAvatar: post.id
            }
          } : null
      })
    }

    const getId = post => post.id
    const getAuthor = post => post.author.name
    const getContent = post => post.content
    const getImage = post => post.image
    const getCreatedAt = post => post.createdAt
    const getLikesCount = post => post.likesPosts.length
    const getCommentsCount = post => post.comments.length
    const isMine = post => state.me?.posts?.find(({ id }) => id === post.id)
    const isLiked = post => state.me?.likesPosts?.find(({ postId }) => postId === post.id)

    const onGoToCommentsToComment = post => {
      router.push({
        name: `Comments`,
        params: {
          postOrCommentId: post.id,
          postOrComment: `post`
        },
        query: {
          autofocus: true
        }
      })
    }

    const onGoToComments = post => {
      router.push({
        name: `Comments`,
        params: {
          postOrCommentId: post.id,
          postOrComment: `post`
        }
      })
    }

    return {
      ...toRefs(state),
      onLike,
      onUnlike,
      onClickMore,
      getId,
      getAuthor,
      getContent,
      getImage,
      getCreatedAt,
      getLikesCount,
      getCommentsCount,
      isLiked,
      onGoToAuthor,
      onGoToPublish,
      onGoToComments,
      onGoToCommentsToComment,
      label
    }
  }
}
</script>
